import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import ParkinglocationModel from './ParkinglocationModel.js';

const BASE = BaseModel.getApiBasePath() + '/api/v1/checker/offenses';

export default new class CheckingOffensesModel {

  constructor() { }

  async get(id) {
    try {
      let offenseResponse = await axios.get(BASE + '/' + id, { params: { access_token: UserModel.getAccessToken() } });
      let locationResponse = await ParkinglocationModel.get(offenseResponse.data.locationId);      
      let location = locationResponse;
      let offense = offenseResponse.data;
      offense.locationCode = location.Code;
      offense.locationName = location.Name;
      offense.locationCodeName = location.Code + ' - ' + location.Name;
      return offense;
    } catch (err) {
      return err;
    }
  }

  getAll(locationId = null, dateFrom = null, dateTo = null, plate = null) {
    var filter = {};

    // Location filter
    if (locationId) {
      filter = _.merge(filter, { where: { locationId: locationId } });
    }

    // Date range filter
    if (dateFrom && dateTo) {
      filter = _.merge(filter, { where: { and: [{ timestamp: { gte: dateFrom } }, { timestamp: { lte: dateTo } }] } });
    }

    // Plate filter
    if (plate) {
      filter = _.merge(filter, { where: { plate: plate } });
    }

    // No hidden items
    filter = _.merge(filter, { where: { hidden: false } });

    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          ParkinglocationModel.getAll()
            .then((pl) => {
              let data = [];
              response.data.map(async (child, idx) => {
                let location = _.find(pl, { id: child.locationId });
                location
                  ? data.push(Object.assign({}, child, { locationCode: location.Code, locationName: location.Name, locationCodeName: location.Code + ' - ' + location.Name }))
                  : data.push(Object.assign({}, child, { locationCodeName: 'Neznámá lokalita' }));
              });
              resolve(data);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  update(id, data) {
    if (data.id !== undefined) {
      delete data.id;
    }
    return new Promise((resolve, reject) => {
      axios.patch(BASE + '/' + id, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.patch(BASE + '/' + id, {
        hidden: true
      }, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        })
    });
  }

  getAttachment(fileName) {
    return new Promise((resolve, reject) => {
      axios.get(BaseModel.getApiBasePath() + '/api/v1/checker/attachments/' + fileName, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error);
        })
    });
  }

  reportToPPR(data) {    
    return new Promise((resolve, reject) => {
      axios.post(BaseModel.getApiBasePath() + '/api/v1/ppr/reports', {
        offenses: data
      }, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        })
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/CheckingOffensesModel.js